import React, { useEffect, useState } from 'react';
import bookingService from '../../../../../../services/booking.service';
import { useEyeconxStore } from '../../../../../../store/eyeconxStore';
import { ClinicInfoPanel } from '../../info/clinicInfoParts';
import ClinicSettingsEmpty from '../../subparts/ClinicSettingsEmpty';
import ClinicSettingsListSkeleton from '../../subparts/ClinicSettingsListSkeleton';

const DoctorsList = ({ onDoctorSelect }) => {
    const clinicId = useEyeconxStore((state) => state.user.clinicId);
    const [doctors, setDoctors] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchDoctors();
    }, [clinicId]);

    const fetchDoctors = async () => {
        setIsLoading(true);
        try {
            const res = await bookingService.getDoctorList(clinicId);
            setDoctors(res.data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const getInitials = (name) => {
        if (!name) return 'DR';
        return name
            .split(' ')
            .map((part) => part[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    if (isLoading) {
        return (
            <ClinicInfoPanel title="Doctors" icon="bi-person-badge">
                <ClinicSettingsListSkeleton rows={4} />
            </ClinicInfoPanel>
        );
    }

    return (
        <ClinicInfoPanel title="Doctors" icon="bi-person-badge">
            {doctors.length === 0 ? (
                <ClinicSettingsEmpty
                    icon="bi-person-x"
                    title="No doctors found"
                    description="Doctors configured for web booking will appear here."
                />
            ) : (
                <div className="clinic-settings-record-list">
                    {doctors.map((doctor, index) => (
                        <div key={doctor.id || index} className="clinic-settings-record-item">
                            <span className="clinic-settings-record-item__avatar">
                                {doctor.photoUrl ? (
                                    <img src={doctor.photoUrl} alt={doctor.name} />
                                ) : (
                                    getInitials(doctor.name)
                                )}
                            </span>
                            <div className="clinic-settings-record-item__main">
                                <h6 className="clinic-settings-record-item__title">
                                    {doctor.name || 'Unknown Doctor'}
                                </h6>
                                <p className="clinic-settings-record-item__meta mb-0">
                                    <span className={`clinic-settings-status-pill ${doctor.isActive ? 'is-open' : 'is-closed'}`}>
                                        {doctor.isActive ? 'Active' : 'Inactive'}
                                    </span>
                                </p>
                            </div>
                            <div className="clinic-settings-record-item__actions">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-light-primary rounded-pill px-3"
                                    onClick={() => onDoctorSelect(doctor)}
                                >
                                    <i className="bi bi-gear me-1"></i>
                                    Manage
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </ClinicInfoPanel>
    );
};

export default DoctorsList;
